import { LicenseRequestsQueue } from "@/features/licenses/components/LicenseRequestsQueue";

/**
 * Cola global de solicitudes de licencia (admin / center_admin).
 */
export default function LicensesPage() {
  return <LicenseRequestsQueue />;
}
